import { styled } from '@mui/material';

export const Wrapper = styled('div')`
    padding-top: ${({ theme }) => theme.spacing(13)};
    text-align: center;
    width: 100%;
`;
